import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteSystem } from '../index';
export const useDeleteSystem = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(deleteSystem, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetAllSystems');
            setAction({
                type: 'success',
                message: 'Removing the system was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
